module.exports = __webpack_public_path__ + "img/d-emb-grandeporte.8b6b453e.png";